// Static export: prerender every route as static HTML.
export const prerender = true;
export const trailingSlash = "always";
